import React from "react"
import "./style.scss"
const index = () => {
  return (
    <div className="extras">
      <h1>Extras</h1>
      <ul>
        <li>Advisory board for local programs</li>
        <li>Start up weekend winner</li>
        <li>Takes music courses on the side</li>
        <li>Game master for local gaming groups</li>
        <li>Eagle Scout; Awarded May 2006</li>
      </ul>
    </div>
  )
}

export default index
